// import { removeBulkUsers } from '../index';
import { remove } from '../index';


export const removeUser = data => {
  return remove('/users/delete-user', data);
};
